import { CHECKSUM_MESSAGE } from '../../types/upload-video';
import type { ChecksumTask } from '../../types/upload-video';

class InternalChecksumTask implements ChecksumTask {
  constructor(
    private worker: Worker,
    private resultPromise: Promise<string | null>,
    private onCancel?: () => void
  ) {
    this.worker = worker;
    this.resultPromise = resultPromise;
    this.onCancel = onCancel;
  }

  public hash(): Promise<string | null> {
    return this.resultPromise;
  }

  public cancel(): void {
    this.onCancel?.();
    this.worker.terminate();
  }
}

function computeChecksum(blob: Blob, onProgress: (progressBytes: number) => void): ChecksumTask {
  /*
  Question mark syntax is required for vite
  Type has been added to vite-client.d.ts
  https://vitejs.dev/guide/features.html#web-workers
  */
  const worker = new Worker(new URL('../worker?worker', import.meta.url), {
    type: 'module',
  });
  let onCancel;
  const resultPromise = new Promise<string | null>((resolve, reject) => {
    worker.onerror = (e) => reject(e.error);
    onCancel = () => {
      resolve(null);
    };
    worker.onmessage = ({ data: message }) => {
      switch (message.type) {
        case CHECKSUM_MESSAGE.PROGRESS:
          onProgress(message.payload);
          break;
        case CHECKSUM_MESSAGE.SUCCESS:
          resolve(message.payload);
          break;
        case CHECKSUM_MESSAGE.ERROR:
          reject(message.payload);
          break;
      }
    };
    worker.postMessage(blob);
  });

  return new InternalChecksumTask(worker, resultPromise, onCancel);
}

export default computeChecksum;
